import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-met-inhouding-dividendbelasting-buitenland',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-met-inhouding-dividendbelasting-buitenland.component.html',
  styleUrl: './tekst-met-inhouding-dividendbelasting-buitenland.component.scss',
})
export class TekstMetInhoudingDividendbelastingBuitenlandComponent {}
